import Dialog from '@mui/material/Dialog'
import Box from '@mui/material/Box'
import useModalsActions from 'store/actions/modals'
import { useModal } from 'store/selectors'
import AnimatedVideoPlayer from 'components/core/AnimatedVideoPlayer'

const AnimatedVideoPlayerModal = () => {
  const {
    isOpen,
    params: { shareCode },
  } = useModal('animatedVideoPlayer')
  const { closeModal } = useModalsActions()

  return (
    <Dialog
      open={isOpen}
      onClose={closeModal.bind(null, 'animatedVideoPlayer')}
    >
      <Box
        sx={{
          backgroundColor: 'background.default',
          p: 4,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        {shareCode && (
          <Box
            sx={{
              height: '750px',
              width: '420px',
            }}
          >
            <AnimatedVideoPlayer shareCode={shareCode} />
          </Box>
        )}
      </Box>
    </Dialog>
  )
}

export default AnimatedVideoPlayerModal
